// URL
export const PAYPAL_SDK = 'https://www.paypal.com/sdk/js';
export const PAYPAL_INIT = '/mcc-checkout/v2/paypal/init';
export const MYCHECKOUT_SAVED_PAYPAL = '/mycheckout/checkout?navigation=savedPayPal';
export const SIGN_IN = 'auth/view/checkout/signin';
export const NUCLEUS_CHECKOUT_SAVED_PAYPAL = '/checkout?savedPaypal=true';
export const CART_VIEW_PREFERENCE = 'cart.view-preference';